<template>
  <div class="vz-related">
    <transition name="vz-t-fade" mode="out-in" @enter="emitEnter">
      <div class="vz-related-loading" v-if="loading" key="related-loading">
        <i class="ic-loader vz-spin" />
      </div>

      <div
        class="vz-related-empty"
        v-else-if="titles.length === 0"
        key="related-empty"
      >
        <i class="ic-frown" />
        <span>Nenhum conteúdo relacionado.</span>
      </div>

      <div v-else class="vz-related-list" key="related-list">
        <titles-list-item
          class="vz-related-item vz-small-item"
          v-for="item in titles"
          :key="item.id"
          :info="item"
          :show-info="false"
          :show-favorite="false"
          :use-landscape-cover="false"
          @play="playTitle(item)"
          @rent="selectTitle(item)"
          @select="selectTitle(item)"
        >
        </titles-list-item>
      </div>
    </transition>
  </div>
</template>

<script>
import TitlesListItem from '@/components/molecules/titles-list-item.vue';

export default {
  name: 'RelatedTitles',
  emits: ['select', 'play', 'transition-enter'],
  components: { TitlesListItem },
  props: {
    titleId: {
      type: [String, Number],
      default: ''
    }
  },

  data: () => ({
    loading: false,
    titles: []
  }),

  beforeMount() {
    const { state } = this.$store;
    this.loading = true;
    this.$api.content
      .getRelatedTitles(
        state.config.distributor.id,
        state.user.session.token,
        this.titleId
      )
      .then((response) => {
        if (response?.data?.titles?.length) {
          this.titles = response.data.titles;
        } else {
          return Promise.reject(response);
        }
      })
      .catch((err) => {
        this.$store.dispatch('ui/consoleLog', err.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    selectTitle(titleItem) {
      if (!titleItem?.canOpenDetails) {
        return;
      }

      this.$emit('select', titleItem);
    },

    playTitle(titleItem) {
      this.$emit('play', titleItem);
    },

    emitEnter() {
      this.$emit('transition-enter');
    }
  }
};
</script>





















































<style theme="light-theater" scoped>
.vz-related {
  width: 100%;
  height: 100%;
}

.vz-related-loading {
  position: relative;
  width: 100%;
  height: 128px;
}

.vz-related-loading .ic-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.25);
  display: inline-block;
  margin: -8px 0 0 -8px;
}

.vz-related-empty {
  width: 100%;
  padding: 32px 32px;
  text-align: center;
  min-height: 128px;
}

.vz-related-empty .ic-frown {
  font-size: 64px;
  color: rgba(0, 0, 0, 0.3);
}

.vz-related-empty > span {
  display: block;
  font-size: 0.875em;
  margin-top: 12px;
}

.vz-related-list {
  padding: 32px 8px 8px 32px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.vz-related-item {
  margin: 0 16px 16px 0;
}
</style>
